import _ from 'lodash';
import Vue from 'vue';
import { HTTP, SEARCH } from '@/utils/http';
import * as actions from '../types/actions';
import * as getters from '../types/getters';
import * as mutations from '../types/mutations';

const defaultUser = {
  access: {
    account: false,
    articles: false,
    church: true,
    events: true,
    media: true,
    users: false,
  },
  is_active: true,
};

export default {
  actions: {
    async [actions.DO_CREATE_USER]({ commit }, payload) {
      const { data } = await HTTP.post('/users', payload);
      commit(mutations.SET_USER, data.data.users[0]);
      return data;
    },
    async [actions.DO_GET_USER]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.get(`/users/${id}`, { params });
      commit(mutations.SET_USER, data.data.users[0]);
      return data;
    },
    async [actions.DO_GET_USERS]({ commit }, params) {
      const { data } = await HTTP.get('/users', params);
      commit(mutations.SET_USERS, data.data.users);
      return data;
    },
    async [actions.DO_SEARCH_USERS]({ commit }, payload) {
      const { data } = await SEARCH.post('/doxa_users/user/_search', payload);
      const users = data.hits.hits.map(h => h._source);
      commit(mutations.SET_USERS, users);
      return data;
    },
    async [actions.DO_GET_AUTHENTICATED_USER]({ commit }, params) {
      return new Promise((resolve) => {
        const reqParams = Object.assign({}, {
          zoom: 'accounts,permissions',
        }, params);
        HTTP.get('/self', {
          params: reqParams,
        })
          .then((response) => {
            const user = response.data.data.users[0];
            commit(mutations.SET_AUTHENTICATED_USER, user);
            if (user._embedded.accounts.length > 0) {
              const account = user._embedded.accounts[0];
              commit(mutations.SET_ACCOUNT, account);
              resolve();
            }
          });
      });
    },
    async [actions.DO_UPDATE_USER]({ commit }, payload) {
      const { id } = payload;
      const params = Object.assign({}, payload);
      delete params.id;
      const { data } = await HTTP.patch(`/users/${id}`, params);
      commit(mutations.SET_USER, data.data.users[0]);
      return data;
    },
  },
  getters: {
    [getters.GET_AUTHENTICATED_USER]: state => state.authenticated,
    [getters.GET_USER]: state => state.user,
    [getters.GET_USERS]: state => state.users,
    [getters.GET_USERS_REFRESH]: state => state.refresh,
  },
  mutations: {
    [mutations.SET_USER](state, user) {
      state.user = user;
    },
    [mutations.SET_USER_FIELD](state, field) {
      const nodes = field.key.split('.');
      let obj = state.user;
      let i = 0;
      nodes.forEach((node) => {
        i += 1;
        if (i === nodes.length) {
          Vue.set(obj, node, field.val);
        } else {
          obj = obj[node];
        }
      });
    },
    [mutations.SET_USERS](state, users) {
      state.users = users;
    },
    [mutations.SET_USERS_REFRESH](state, refresh) {
      state.refresh = refresh;
    },
    [mutations.SET_AUTHENTICATED_USER](state, authenticated) {
      state.authenticated = authenticated;
    },
    [mutations.UNSET_USER](state) {
      state.user = _.cloneDeep(defaultUser);
    },
    [mutations.UNSET_AUTHENTICATED_USER](state) {
      state.authenticated = {};
    },
  },
  state: {
    authenticated: _.cloneDeep(defaultUser),
    user: _.cloneDeep(defaultUser),
    users: [],
    refresh: false,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js